module.exports = {
	"banks": {
		"new": "New bank",
		"updated_success": "Bank is successfully updated",
		"created_success": "Bank is successfully created",
		"deleted_success": "Bank is successfully deleted",
		"confirm_delete_bank": "Remove bank?",
		"invalid_title": "Enter the title"
	}
};